const CursorIcon = ({ size = 24, color = "#444444", className = "" }) => {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} preserveAspectRatio="none" className={className}>
      <path fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" d="M6.997,18.487C3.503,17.25,1,13.918,1,10c0-4.971,4.029-9,9-9c3.92,0,7.254,2.506,8.489,6.003" strokeLinejoin="miter" />
      <path fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" d="M7.003,14.003C5.787,13.091,5,11.637,5,10c0-2.761,2.239-5,5-5c1.636,0,3.088,0.785,4,2" strokeLinejoin="miter" />
      <polygon fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" points="10,10 11,21 14,18 18,22 22,18 18,14 21,11" strokeLinejoin="miter" />
    </svg>
  );
};

export default CursorIcon;
